<template>
  <div class="group-select-container">
    <div class="select-container">
      <el-select
        clearable
        filterable
        multiple
        reserve-keyword
        v-model="selectGroup"
        popper-class="search-group-select"
      >
        <el-option
          v-for="(group, index) in groupList" :key="index"
          :label="group.text"
          :value="group.id"
        >
          <div class="group-option">
            <span class="label">{{ group.text }} ({{ group.count }})</span>
            <div class="action-btn" v-if="group.id !== -1">
              <i class="group-edit-btn el-icon-edit" @click.stop="editGroup(group)"></i>
              <i class="group-delete-btn el-icon-delete"  @click.stop="deleteGroup(group)"></i>
            </div>
          </div>
        </el-option>
      </el-select>
    </div>
    <editGroupVue
      ref="editGroupDialog"
      :currentGroup="editGroupDialog.group"
      @save="saveEditGroup"
    ></editGroupVue>
    <ConfirmDialog
      v-if="showConfirmDialog"
      :content="$t(`${this.i18nPrefix}.message.deleteGroupMessageTip`)"
      :show.sync="showConfirmDialog"
      :title="$t(`${this.i18nPrefix}.message.deleteGroupMessageTitle`)"
      :loading="false"
      @confirm="handleConfirmDelete"
      @cancel="handleCancelDelete"/>
  </div>
</template>

<script>
import _ from 'lodash'
import editGroupVue from './dialog/editGroup.vue'
import ConfirmDialog from '@/components/dialog/confirmDialog.vue'

export default {
  name: 'group-select',
  components: {
    editGroupVue,
    ConfirmDialog
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    groupList: {
      required: false
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data () {
    const i18nPrefix = 'admin.application.candidateGroup'
    return {
      i18nPrefix,
      loading: true,
      show: false,
      editGroupDialog: {
        group: {}
      },
      showConfirmDialog: false,
      needDeleteGroup: null
    }
  },
  computed: {
    selectGroup: {
      get () {
        return _.map(this.value, 'id')
      },
      set (val) {
        const groupList = this.groupList
        const selectedGroupList = []
        _.forEach(val, groupId => {
          const selectedGroup = _.filter(groupList, group => group.id === groupId)
          selectedGroupList.push(...selectedGroup)
        })
        this.$emit('change', selectedGroupList)
      }
    }
  },
  created () {
  },
  methods: {
    handleLoadGroup (visible) {
      if (visible && this.loadData) {
        this.loading = true
        Promise.resolve(this.loadData(true)).then((data) => {
          this.groupList = data
        }).catch((e) => {
          this.loading = false
          // eslint-disable-next-line no-console
          console.error(e)
        }).finally(() => {
          this.loading = false
        })
      }
    },
    handelSearch () {
      const groupList = this.groupList
      const selectedGroupList = []
      _.forEach(this.selectGroup, groupId => {
        const selectedGroup = _.filter(groupList, group => group.id === groupId)
        selectedGroupList.push(selectedGroup)
      })
      if (!this.value) {
        this.value = selectedGroupList
      }
      this.$emit('change', selectedGroupList)
    },
    editGroup (group) {
      this.editGroupDialog.group = group
      this.$refs.editGroupDialog.openDialog()
    },
    saveEditGroup (groupInfo, callback) {
      this.$emit('saveEditGroup', groupInfo, callback)
    },
    deleteGroup (group) {
      this.showConfirmDialog = true
      this.needDeleteGroup = group
    },
    handleConfirmDelete () {
      if (this.needDeleteGroup) {
        this.$emit('deleteGroup', this.needDeleteGroup)
      }
      this.showConfirmDialog = false
    },
    handleCancelDelete () {
      this.$message({
        type: 'info',
        message: this.$t(`${this.i18nPrefix}.message.cancelDeleteGroup`)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.group-select-container {
}
.search-group-select {
  .group-option {
    display: flex;
    justify-content: space-between;
    .label {}

    .action-btn {
      line-height: inherit;
      margin-left: 10px;
      .group-edit-btn {
        line-height: inherit;
        font-size: 18px;
        margin-right: 20px;
        &:hover {
          color: #0096CC;
          cursor: pointer;
        }
      }

      .group-delete-btn {
        line-height: inherit;
        font-size: 18px;
        &:hover {
          color: #0096CC;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
